import { Directive, ElementRef, AfterViewInit, Output, ViewChild, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map, mergeMap, switchMap } from "rxjs/operators";

@Directive({
    selector: '[lazy-load]',
})
export class LazyLoadDirective implements AfterViewInit {
    @Output('load-more') loadMore: EventEmitter<void> = new EventEmitter<void>();

    constructor(private element: ElementRef) {
    }
    ngAfterViewInit(): void {
        this.createAndObserve().pipe(
            filter((isVisible: boolean) => isVisible),
        ).subscribe(() => {
            this.loadMore.emit();
        });
    }

    createAndObserve(): Observable<boolean> {
        return new Observable(observer => {
            const intersectionObserver = new IntersectionObserver(entries => {
                observer.next(entries);
            });

            intersectionObserver.observe(this.element.nativeElement);

            return () => { intersectionObserver.disconnect(); };
        }).pipe(
            mergeMap((entries: IntersectionObserverEntry[]) => entries),
            map(entry => entry.isIntersecting),
            distinctUntilChanged()
        );
    }
}